// Mood Board Constants and Configuration

// Print-optimized sizes (in pixels at 150 DPI)
export const CANVAS_PRESETS = {
  'letter-landscape': { width: 1650, height: 1275, label: 'Letter Landscape (11x8.5")' },
  'letter-portrait': { width: 1275, height: 1650, label: 'Letter Portrait (8.5x11")' },
  'tabloid-landscape': { width: 2550, height: 1650, label: 'Tabloid Landscape (17x11")' },
  'tabloid-portrait': { width: 1650, height: 2550, label: 'Tabloid Portrait (11x17")' },
  'a4-landscape': { width: 1754, height: 1240, label: 'A4 Landscape' },
  'a4-portrait': { width: 1240, height: 1754, label: 'A4 Portrait' },
  'presentation': { width: 1920, height: 1080, label: 'Presentation (16:9)' },
};

export const FONT_FAMILIES = [
  { value: 'Cormorant Garamond', label: 'Cormorant Garamond (Heading)' },
  { value: 'Manrope', label: 'Manrope (Body)' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Times New Roman', label: 'Times New Roman' },
];

export const GRID_SIZE = 20;

// Shape library - basic shapes
export const SHAPE_LIBRARY = [
  { id: 'rectangle', name: 'Rectangle', type: 'rectangle', icon: '▢' },
  { id: 'rounded-rect', name: 'Rounded Rectangle', type: 'rectangle', icon: '▢', cornerRadius: 20 },
  { id: 'square', name: 'Square', type: 'rectangle', icon: '■', aspectRatio: 1 },
  { id: 'circle', name: 'Circle', type: 'ellipse', icon: '●', aspectRatio: 1 },
  { id: 'ellipse', name: 'Ellipse', type: 'ellipse', icon: '⬭' },
  { id: 'line-h', name: 'Horizontal Line', type: 'line', icon: '―' },
  { id: 'line-v', name: 'Vertical Line', type: 'line', icon: '│', rotation: 90 },
  { id: 'line-d', name: 'Diagonal Line', type: 'line', icon: '╱', rotation: 45 },
  { id: 'triangle', name: 'Triangle', type: 'polygon', icon: '△', points: '0.5,0 1,1 0,1' },
  { id: 'diamond', name: 'Diamond', type: 'polygon', icon: '◇', points: '0.5,0 1,0.5 0.5,1 0,0.5' },
  { id: 'pentagon', name: 'Pentagon', type: 'polygon', icon: '⬠', points: '0.5,0 1,0.38 0.81,1 0.19,1 0,0.38' },
  { id: 'hexagon', name: 'Hexagon', type: 'polygon', icon: '⬡', points: '0.25,0 0.75,0 1,0.5 0.75,1 0.25,1 0,0.5' },
  { id: 'star', name: 'Star', type: 'polygon', icon: '★', points: '0.5,0 0.61,0.35 1,0.35 0.68,0.57 0.79,0.91 0.5,0.7 0.21,0.91 0.32,0.57 0,0.35 0.39,0.35' },
  { id: 'arrow-right', name: 'Arrow Right', type: 'polygon', icon: '→', points: '0,0.3 0.6,0.3 0.6,0 1,0.5 0.6,1 0.6,0.7 0,0.7' },
  { id: 'arrow-left', name: 'Arrow Left', type: 'polygon', icon: '←', points: '1,0.3 0.4,0.3 0.4,0 0,0.5 0.4,1 0.4,0.7 1,0.7' },
  { id: 'chevron-right', name: 'Chevron Right', type: 'polygon', icon: '›', points: '0,0 0.5,0.5 0,1 0.3,1 0.8,0.5 0.3,0' },
  { id: 'heart', name: 'Heart', type: 'path', icon: '♥', path: 'M0.5,0.9 C0.1,0.6 0,0.3 0.15,0.15 C0.3,0 0.5,0.1 0.5,0.3 C0.5,0.1 0.7,0 0.85,0.15 C1,0.3 0.9,0.6 0.5,0.9 Z' },
];

// Icon library - common design/architecture icons (using SVG paths)
export const ICON_LIBRARY = [
  { id: 'home', name: 'Home', icon: '🏠', path: 'M0.5,0.1 L0.95,0.45 L0.95,0.95 L0.6,0.95 L0.6,0.6 L0.4,0.6 L0.4,0.95 L0.05,0.95 L0.05,0.45 Z' },
  { id: 'lightbulb', name: 'Light Bulb', icon: '💡', path: 'M0.5,0.1 C0.25,0.1 0.15,0.3 0.15,0.45 C0.15,0.6 0.3,0.7 0.35,0.75 L0.35,0.9 L0.65,0.9 L0.65,0.75 C0.7,0.7 0.85,0.6 0.85,0.45 C0.85,0.3 0.75,0.1 0.5,0.1 Z' },
  { id: 'chair', name: 'Chair', icon: '🪑', path: 'M0.2,0.3 L0.8,0.3 L0.8,0.5 L0.2,0.5 Z M0.25,0.5 L0.25,0.95 M0.75,0.5 L0.75,0.95 M0.3,0.1 L0.3,0.3 M0.7,0.1 L0.7,0.3' },
  { id: 'table', name: 'Table', icon: '🪑', path: 'M0.1,0.4 L0.9,0.4 L0.9,0.5 L0.1,0.5 Z M0.2,0.5 L0.2,0.9 M0.8,0.5 L0.8,0.9' },
  { id: 'sofa', name: 'Sofa', icon: '🛋', path: 'M0.1,0.4 L0.9,0.4 L0.9,0.7 L0.1,0.7 Z M0.05,0.35 L0.15,0.35 L0.15,0.75 L0.05,0.75 Z M0.85,0.35 L0.95,0.35 L0.95,0.75 L0.85,0.75 Z' },
  { id: 'bed', name: 'Bed', icon: '🛏', path: 'M0.05,0.5 L0.95,0.5 L0.95,0.8 L0.05,0.8 Z M0.05,0.35 L0.3,0.35 L0.3,0.5 L0.05,0.5 Z' },
  { id: 'door', name: 'Door', icon: '🚪', path: 'M0.25,0.1 L0.75,0.1 L0.75,0.9 L0.25,0.9 Z M0.65,0.5 C0.68,0.5 0.68,0.55 0.65,0.55 C0.62,0.55 0.62,0.5 0.65,0.5' },
  { id: 'window', name: 'Window', icon: '🪟', path: 'M0.15,0.15 L0.85,0.15 L0.85,0.85 L0.15,0.85 Z M0.5,0.15 L0.5,0.85 M0.15,0.5 L0.85,0.5' },
  { id: 'plant', name: 'Plant', icon: '🌿', path: 'M0.5,0.9 L0.5,0.5 M0.3,0.6 Q0.5,0.3 0.5,0.5 M0.7,0.6 Q0.5,0.3 0.5,0.5 M0.2,0.4 Q0.5,0.1 0.5,0.5 M0.8,0.4 Q0.5,0.1 0.5,0.5' },
  { id: 'lamp', name: 'Lamp', icon: '🪔', path: 'M0.3,0.2 L0.7,0.2 L0.6,0.5 L0.4,0.5 Z M0.45,0.5 L0.45,0.85 L0.55,0.85 L0.55,0.5 M0.3,0.85 L0.7,0.85 L0.7,0.9 L0.3,0.9 Z' },
  { id: 'outlet', name: 'Outlet', icon: '🔌', path: 'M0.2,0.2 L0.8,0.2 L0.8,0.8 L0.2,0.8 Z M0.35,0.4 L0.35,0.5 M0.65,0.4 L0.65,0.5 M0.5,0.6 C0.45,0.6 0.45,0.7 0.55,0.7 C0.55,0.6 0.5,0.6 0.5,0.6' },
  { id: 'switch', name: 'Switch', icon: '⏻', path: 'M0.3,0.2 L0.7,0.2 L0.7,0.8 L0.3,0.8 Z M0.4,0.35 L0.6,0.35 L0.6,0.55 L0.4,0.55 Z' },
  { id: 'faucet', name: 'Faucet', icon: '🚰', path: 'M0.3,0.5 L0.7,0.5 L0.7,0.6 L0.3,0.6 Z M0.5,0.6 L0.5,0.8 M0.4,0.8 L0.6,0.8' },
  { id: 'toilet', name: 'Toilet', icon: '🚽', path: 'M0.3,0.2 L0.7,0.2 L0.7,0.4 L0.3,0.4 Z M0.25,0.4 C0.25,0.9 0.75,0.9 0.75,0.4' },
  { id: 'bathtub', name: 'Bathtub', icon: '🛁', path: 'M0.1,0.4 L0.9,0.4 L0.9,0.45 L0.1,0.45 Z M0.15,0.45 C0.15,0.8 0.85,0.8 0.85,0.45' },
  { id: 'check', name: 'Checkmark', icon: '✓', path: 'M0.15,0.5 L0.4,0.75 L0.85,0.25' },
  { id: 'x-mark', name: 'X Mark', icon: '✗', path: 'M0.2,0.2 L0.8,0.8 M0.8,0.2 L0.2,0.8' },
  { id: 'plus', name: 'Plus', icon: '+', path: 'M0.5,0.2 L0.5,0.8 M0.2,0.5 L0.8,0.5' },
  { id: 'minus', name: 'Minus', icon: '−', path: 'M0.2,0.5 L0.8,0.5' },
];

// Help/Training content for all tools
export const HELP_CONTENT = {
  overview: {
    title: 'Mood Board Overview',
    content: `Welcome to the Mood Board Editor! This tool lets you create professional design presentations.

**Quick Start:**
1. Click anywhere on the canvas to set where new items appear
2. Use the toolbar to add text, shapes, or images
3. Click elements to select and edit them
4. Drag to move, use handles to resize/rotate
5. Save and export when done`
  },
  text: {
    title: 'Text Tool',
    content: `**Adding Text:**
• Click the "T" icon or press T
• Text appears at your last canvas click position
• Double-click text to edit content

**Formatting:**
• Bold (B) and Italic (I) buttons
• Left, Center, Right alignment
• Adjust font, size, and color

**Leader Lines (Callout Arrows):**
• Toggle "Leader Line" in properties
• Drag handles to shape the line:
  - 🟢 Green = Start point
  - 🔵 Blue = First curve control
  - 🟣 Purple = Second curve control
  - 🟤 Terracotta = Arrow tip
• Use both curve points for S-curves`
  },
  shapes: {
    title: 'Shapes & Icons',
    content: `**Quick Shapes:**
• Rectangle and Ellipse buttons in toolbar
• Click the Layers icon for full library

**Shape Library:**
• 16 basic shapes (rectangles, circles, polygons)
• 20+ icons (furniture, fixtures, symbols)

**Editing Shapes:**
• Drag to move
• Corner handles to resize
• Rotation handle at top
• Adjust fill/stroke colors in properties`
  },
  images: {
    title: 'Images',
    content: `**Adding Images:**
• Camera icon = Add from project clips
• Upload icon = Upload from computer
• Or paste image URL

**Cutout Tool:**
• Select image, click Scissors icon
• Click to add points around item
• Minimum 3 points required
• Creates transparent background

**SpecNum Tags:**
• Auto-assigned from your clip library
• Toggle visibility with Eye icon
• Customize tag appearance in properties`
  },
  layers: {
    title: 'Layer Order',
    content: `**Arranging Elements:**
• ↑↑ Bring to Front
• ↑ Bring Forward (one level)
• ↓ Send Backward (one level)
• ↓↓ Send to Back

**Tips:**
• Text labels should be on top
• Background shapes go to back
• Use layer order for overlapping effects`
  },
  shadows: {
    title: 'Shadows',
    content: `**Adding Depth:**
• Toggle Shadow ON in properties
• Adjust blur for softness
• Offset X/Y moves shadow position
• Opacity controls intensity

**Best Practices:**
• Subtle shadows (blur 10-15, opacity 20-30%)
• Consistent direction across all elements
• Use for product images to "lift" them`
  },
  legend: {
    title: 'Spec Legend',
    content: `**Specifications Legend:**
• Click List icon to show/hide
• Drag to reposition
• Auto-lists all items with SpecNums

**SpecNum System:**
• Items from clips get auto-numbered
• Format: CATEGORY-NUMBER (e.g., FUR-001)
• Tracks materials across your project`
  },
  export: {
    title: 'Export & Share',
    content: `**Saving:**
• Auto-saves every 2 seconds
• Manual save with Save button

**Exporting:**
• Click Export for PNG image
• Includes header with branding
• Print-optimized resolution

**Canvas Sizes:**
• Letter, Tabloid, A4 available
• Presentation (16:9) for screens`
  }
};
